import React, { useState } from "react";
import { SideBar } from "../component/SideBar";
import MobileNavbar from "../component/MobileNavbar";

const SketchOfMyProfilePage = () => {
  const [showWarning, setShowWarning] = useState(false);

  const handleRightClick = (e) => {
    e.preventDefault();
    setShowWarning(true);
  }
  return (
    <>
      <MobileNavbar />
      <div className="min-h-screen text-[16px] bg-white font-sans text-gray-700 flex justify-center lg:pt-24 sm:pt-5 md:pt-10 pt-5 gap-40">

        <SideBar />
        {
          showWarning && (
            <div className="bg-gray-700" style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: 'white',
              padding: '6px 15px',
              zIndex: 1000,
              fontSize: '10px'
            }}>
              <div className="flex justify-between mb-3">
                <h3 className="font-bold text-md">
                  WARNING
                </h3>
                <button
                  onClick={() => setShowWarning(false)}
                  style={{
                    marginLeft: '10px',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 'bolder',
                  }}
                >
                  X
                </button>
              </div>
              <span>
                All content is protected by copyright and may not be <br /> downloaded or copied.
              </span>

            </div>
          )
        }
        <div className="w-full max-w-3xl">
          <div className="lg:max-h-[466px] max-h-[75vh] overflow-y-auto text-sm text-gray-700 px-4 lg:mx-0 md:mx-0 mx-1">
            <img
              src="/images/sketchOfMyProfilePage/01.jpg"
              alt="Art Illustration"
              className="lg:float-left md:float-left float-none lg:w-64 md:w-64 h-auto lg:mr-10 md:mr-10 lg:px-0 md:px-0 px-10 mr-0"
              onContextMenu={(e) => {
                handleRightClick(e)
              }}
            />
            <div className="mb-4 leading-6 [word-spacing:3px] lg:text-left md:text-left text-center">
              <h1 className="text-[16px] text-gray-700 lg:mt-16 md:mt-16 mt-10">
                Paramita Chakraborty (she/her/hers)
              </h1>
              <p className="lg:text-[16px] md:text-[16px] italic text-gray-700">
                An artist, educator, interior designer, and a podcaster
              </p>
            </div>
            <section className="mb-6 lg:mt-28 md:mt-28 mt-5">
              <h2 className="text-[16px] font-semibold  pb-2 mb-2">
                Professional Education
              </h2>
              <ul className="ml-4 text-[16px] space-y-2 flex flex-col gap-2 leading-6 [word-spacing:3px]">
                <li>
                  Master of Fine Arts (M.F.A. Studio Art), Specialization in Drawing and
                  Painting with interdisciplinary course works in Sculpture, Photography and
                  Animation from the School of Visual Arts, Pennsylvania State University, PA,
                  USA. 3.9 GPA on a 4 scale.
                </li>
                <li>
                  Master of Fine Arts (M.F.A.) in Painting from Kala Bhavana, (Institute of
                  Fine Arts) Visva-Bharati University, Santiniketan, India. 71.3% Marks. Class
                  I, Rank 1.
                </li>
                <li>
                  Bachelor of Fine Arts (B.F.A.) with specialization in Painting from Kala
                  Bhavana, (Institute of Fine Arts) Visva-Bharati University, Santiniketan,
                  India. 69.1% Marks. Class I, Rank 1.
                </li>
              </ul>

            </section>

            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2">
                Awards and Scholarships
              </h2>
              <ul className="list-disc text-[16px] ml-4 flex flex-col gap-1 space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  Granted full tuition waiver in the M.F.A. Studio Art Program,
                  Drawing and Painting Department, School of Visual Arts,
                  Pennsylvania State University, PA, USA. 2018 - 2020.
                </li>
                <li>
                  Pollock-Krasner Foundation Grant, New York, USA. 2013 - 2014.
                </li>
                <li>
                  'Camlin India' Eurotour award to visit major art galleries and
                  museums in London and Paris. 2005.
                </li>
                <li>
                  First prize award winner in student category (acrylic medium),
                  Eastern Regional Art Exhibition of the Camlin Art Foundation,
                  India. 2003.
                </li>
                <li>
                  Merit Scholarship from Kala Bhavana (Institute of Fine Arts),
                  Visva-Bharati University, Santiniketan, India in B.F.A. and
                  M.F.A. Level for securing the first position across all the
                  departments. 2003 and 2005.
                </li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2">
                Teaching Experiences
              </h2>
              <ul className="list-disc ml-4 text-[16px] flex flex-col gap-1  space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  Currently working as an Assistant Professor in the Drawing and
                  Painting Department at the Government College of Art and Craft,
                  Kolkata, India. 2020 – present time.
                </li>
                <li>
                  Teaching Assistantship in SoVA (School of Visual Arts),
                  Pennsylvania State University, PA, USA. 2018 - 2020.
                </li>
              </ul>
            </section>
            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2">
                Eligibility for Assistant Professorship
              </h2>
              <ul className="ml-4 text-[16px] flex flex-col gap-1  space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  University Grants Commission NET (National Eligibility Test)
                  qualified, India.
                </li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2">Publication </h2>
              <ul className="ml-4 text-[16px] flex flex-col gap-1 list-disc space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  Article entitled 'Fantasy World' published in Art Etc: Emami
                  Chisel Art Pvt. Ltd, Kolkata, India. Volume 1, No 1, June 2009.
                </li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2">
                Experience in Illustration{" "}
              </h2>
              <ul className="ml-4 text-[16px] flex flex-col gap-1 list-disc  space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  Cover designing and illustration for "Nirbachito Kobita"
                  (Selected poems by Kamalaksha Gangopadhyay), published under
                  Bijayan Publishing house. Kolkata, India. 2012.
                </li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2">Exhibitions</h2>
              <ul className="ml-4 text-[16px] flex flex-col gap-1 list-disc space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  “The Dark Wood and the Vivid Fireflies” - a solo exhibition of
                  paintings, sculptures and installations, SoVA (School of Visual
                  Arts), University Park, Pennsylvania State University, PA, USA.
                  March - April 2020.
                </li>
                <li>
                  "Hangover Smoothie" a group exhibition of second year M.F.A.
                  students, Edwin W. Zoller Gallery, University Park, Pennsylvania
                  State University, PA, USA. September 2019.
                </li>
                <li>
                  Participant in grad students' exhibition, Borland Building,
                  University Park, Pennsylvania State University, PA, USA. April -
                  May 2019.
                </li>
                <li>
                  Participant in grad students' annual exhibition, Hub - Robeson
                  Gallery, University Park, Pennsylvania State University, PA,
                  USA. March - April 2019.
                </li>
                <li>
                  "Free Beer" a group exhibition of first year M.F.A. students,
                  Edwin W. Zoller Gallery, University Park, Pennsylvania State
                  University, PA, USA. January 2019.
                </li>
                <li>
                  Participant in “CIMA Awards Show”, CIMA Art Gallery, Centre of
                  International Modern Art, Kolkata, India. 2015 and 2017.
                </li>
                <li>
                  "The Saffron Rebel - the one & only Swami" a group exhibition
                  organized by "Creative Wave" commemorating 150th birthday
                  ceremony of Swami Vivekananda at the Indian Council for Cultural
                  Relations, Rabindranath Tagore Centre (Ministry of External
                  Affairs, Government of India), Kolkata, India. January 2014.
                </li>
                <li>
                  "Festipotes", Trevingard Hamlet, Bubry, Brittany, France.
                  November 2012.
                </li>
                <li>
                  "Ricosaxo festivities", Trevingard Hamlet, Bubry, Brittany,
                  France, September 2012.
                </li>
                <li>
                  "Dreams and Nightmares" a solo exhibition of drawings, paintings
                  and installations at the Indian Council for Cultural Relations,
                  Rabindranath Tagore Centre (Ministry of External Affairs,
                  Government of India), Kolkata, India. November 2009.
                </li>
                <li>
                  Participated in an exhibition of selected artists from Camlin
                  Eurotour Award Winners, Jahangir Art Gallery, Mumbai, India.
                  June 2009.
                </li>
                <li>
                  "Measured Cadences" a group show organized by Kolkata Artists
                  Circle based on works of artists from Santiniketan held at the
                  Lokayata Hall, Mulk Raj Anand Centre, New Delhi, India. March
                  2008.
                </li>
                <li>
                  "Mind's Journey" a group show of young contemporaries of Kolkata
                  held at the Ganges Art Gallery, Kolkata, India. March 2008.
                </li>
                <li>
                  "Young Contemporaries 2007" a group exhibition at the Aakriti
                  Art Gallery, Kolkata, India. September 2007 curated by Jogen
                  Chowdhury.
                </li>
                <li>
                  Participant in inaugural exhibition of Ganges Art Gallery,
                  Kolkata, India. September 2007.
                </li>
                <li>
                  "Ripe Green" a group show of young contemporaries held at the
                  Nakshatra Art Gallery, Kolkata, India. April 2007 curated by
                  Pranab Ranjan Roy.
                </li>
                <li>
                  Selected for the E-Gallery exhibition of the Eye Within
                  Foundation, Kolkata, India. February 2007.
                </li>
                <li>
                  Participant in Annual Art Exhibition at the Birla Academy of Art
                  and Culture, Kolkata, India. January 2006.
                </li>
                <li>
                  Participant in group exhibition at the Birla Academy of Art and
                  Culture, Kolkata, India. December 2004.
                </li>
                <li>
                  Participant in the second, third, and fourth Eastern Regional
                  Art Exhibition of Camlin Art Foundation held at the Academy of
                  Fine Arts, Kolkata, India in 2001, 2002 and 2003.
                </li>
                <li>
                  "Voyage of Discovery" a solo exhibition of Paintings at the
                  Gaganendra Art Gallery, Kolkata, India. February 2000.
                </li>
              </ul>
            </section>

            {/* Reviews */}
            <section className="mb-6">
              <h2 className="text-[16px] font-semibold pb-2 mb-2 ">
                Reviews of Exhibitions
              </h2>
              <ul className="ml-4 text-[16px] flex flex-col gap-1 list-disc space-y-1 leading-6 [word-spacing:3px]">
                <li>
                  Indian Contemporary Art Journal, Mumbai, India. Volume 2,
                  Issue-II 2010 by Nanak Ganguly.
                </li>
                <li>
                  Anandabazar Patrika, Kolkata, India. 30 January 2010 by Mrinal
                  Ghosh.
                </li>
                <li>
                  Dainik Statesman, Kolkata, India. 9 January 2010 by Debabrata
                  Chakraborty.
                </li>
                <li>
                  <a
                    href="http://getahead.rediff.com/report/2009/nov/09/art-is-nothing-but-a-shade-of-the-mind.htm"
                    target="_blank"
                    className=" underline ml-1"
                    rel="noopener noreferrer">
                    Rediff: "Art is Nothing but a Shade of the Mind"
                  </a>
                  , India. 9 November 2009 by Indrani Roy Mitra.
                </li>
                <li>Dainik Statesman, Kolkata, India. 9 November 2009.</li>
                <li>The Hindustan Times, Kolkata, India. 5 November 2009.</li>
                <li>Anandabazar Patrika, Kolkata, India. 2 November 2009.</li>
                <li>Desh, Kolkata, India. 2 June 2008 by Sovan Som.</li>
                <li>The Times of India, Kolkata, India. 21 March 2008.</li>
                <li>
                  Dainik Statesman, Kolkata, India. 20 October 2007 by Debabrata
                  Chakraborty.
                </li>
                <li>
                  <a
                    href="http://www.mattersofart.com"
                    target="_blank"
                    rel="noopener noreferrer">
                    Matters of Art
                  </a>
                  , India. 5 October 2007 by Sarmistha Maiti.
                </li>
                <li>Desh, Kolkata, India. 2 October 2007 by Sovan Som.</li>
                <li>The Telegraph, Kolkata, India. 18 September 2007.</li>
                <li>
                  Anandabazar Patrika, Kolkata, India. 7 May 2000 by Mrinal Ghosh.
                </li>
                <li>Pratidin, Kolkata, India. 10 March 2000 by Sujit Haldar.</li>
                <li>
                  The Hindustan Times, Kolkata, India. 1 March 2000 by Amrita
                  Mukherjee.
                </li>
                <li>The Statesman, Kolkata, India. 23 February 2000.</li>
                <li>Anandabazar Patrika, Kolkata, India. 21 February 2000.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-[16px] font-semibold pb-2 mb-2">
                Interests and Other Achievements
              </h2>
              <div className="text-[16px] text-gray-700 ml-2 flex flex-col gap-3 leading-6 [word-spacing:3px]">
                <p>French language and literature.</p>
                <p>
                  Diploma in French (three-year course) offered by the Department of English and Other Modern
                  European Languages of Visva-Bharati University, Santiniketan, India. 65% Marks. Class I, Rank 1.
                </p>
                <p>Amateur singer, writer and a passionate cook.</p>
              </div>
            </section>
            <div className="flex justify-start mt-8">
              <img
                src="/images/sketchOfMyProfilePage/02.jpg"
                alt="Art Illustration"
                className="w-full max-w-[418px] h-auto"
                onContextMenu={(e) => {
                  handleRightClick(e)
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SketchOfMyProfilePage;
